<template>
    <div v-dusk="'closing-datepicker'" class="row">
        <div class="col-md-4">
            <BootstrapDatepicker
                ref="datepicker"
                class="closing-datepicker mb-2"
                v-model="selectedDate"
                :disabled-dates="disabledDates"
                :day-cell-content="getDayCellContent"
            />
        </div>
    </div>
</template>

<script>
import BootstrapDatepicker from './BootstrapDatepicker';

import {momentDay, momentDaysAreSame} from "../moment-with-helpers";

export default {
    components: {
        BootstrapDatepicker,
    },

    props: {
        endPreparationDate: {
            type: Object,
            required: true,
        },
        value: {
            type: Date,
            required: false,
        },
    },

    data() {
        return {
            selectedDate: this.value,
        };
    },

    methods: {
        getDayCellContent(params) {
            return `<span class="day-blank">${params.date}</span>`;
        },

        open() {
            this.$refs.datepicker.close();
            this.$refs.datepicker.showCalendar();
            this.$refs.datepicker.$el.querySelector('input').focus();
            this.$refs.datepicker.$el.querySelector('input').addEventListener('blur', () => {
                if (this.onClose) {
                    this.onClose();
                }
            });

            this.$emit('opened');
        },
    },

    watch: {
        endPreparationDate(newDate, oldDate) {
            this.selectedDate = null;
        },

        selectedDate(newDate, oldDate) {
            if ((newDate === null && oldDate !== null)
             || (newDate !== null && oldDate === null)
             || (newDate !== null && oldDate !== null && !momentDaysAreSame(newDate, oldDate))) {
                this.$emit('input', newDate);
            }
        },
    },

    computed: {
        disabledDates() {
            return {
                customPredictor: (date) => {
                    return momentDay(date).isSameOrAfter(this.endPreparationDate.date);
                }
            };
        },
    }
}
</script>
